module.exports = __webpack_public_path__ + "static/media/Nota sabor del norte.b9d0d92a.jpg";